/** @docs-private */
export type Constructor<T> = new(...args: any[]) => T;
